<template>
  <div>

    <!-- ================= LLUVIA DE SOBRES ================= -->
    <section ref="raiz" class="lluvia-sobres">

      <!-- ✨ ESTRELLAS -->
      <img ref="star1" src="@/assets/es.png" class="star star-1" />
      <img ref="star2" src="@/assets/es.png" class="star star-2" />
      <img ref="star3" src="@/assets/es.png" class="star star-3" />
      <img ref="star4" src="@/assets/es.png" class="star star-4" />

      <div class="contenido">
        <h2 ref="tituloRef" class="titulo">
          <span class="serif">Lluvia</span><br />
          <span class="script">de Sobres</span>
        </h2>

        <p ref="textoRef" class="texto">
        
<br> <br> 
          Gracias por su cariño, el regalo es opcional, ¡tu presencia obligatoria! ✨   <br>  <br>Sí deseas tener un detalle conmigo, el día del evento habrá un buzón de sobres.
        </p>

        <img ref="sobreRef" :src="sobrePng" alt="Sobre" class="icono-sobre" />

        <p ref="graciasRef" class="gracias">¡Lluvia de sobres!</p>

        <div ref="separadorRef" class="separador"></div>
      </div>

      <div ref="lluviaIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaDer" class="lluvia lluvia-der"></div>
    </section>

    <!-- ================= CUENTA ================= -->
    <section ref="raizNinos" class="lluvia-sobres">

      <!-- ✨ ESTRELLAS TAMBIÉN -->
      <img ref="star5" src="@/assets/es.png" class="star star-5" />
      <img ref="star6" src="@/assets/es.png" class="star star-6" />

   

      <div ref="lluviaNinosIzq" class="lluvia lluvia-izq"></div>
      <div ref="lluviaNinosDer" class="lluvia lluvia-der"></div>
    </section>

  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {

    const raiz = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const graciasRef = ref(null)
    const separadorRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    const raizNinos = ref(null)
    const textoNinosRef = ref(null)
    const lluviaNinosIzq = ref(null)
    const lluviaNinosDer = ref(null)

    // ⭐ estrellas
    const star1 = ref(null)
    const star2 = ref(null)
    const star3 = ref(null)
    const star4 = ref(null)
    const star5 = ref(null)
    const star6 = ref(null)

    let st1 = null

    const crearLluvia = (contenedor) => {
      if (!contenedor) return

      for (let i = 0; i < 10; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.className = 'sobre-lluvia'
        contenedor.appendChild(el)

        gsap.fromTo(
          el,
          { y: -40, opacity: 0 },
          {
            y: 200,
            opacity: 1,
            duration: 2,
            ease: 'power2.out',
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      st1 = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          tl.from(tituloRef.value, { opacity: 0, y: -20 })
            .from(textoRef.value, { opacity: 0, y: 10 }, '-=0.2')
            .from(sobreRef.value, { opacity: 0, y: -40 }, '-=0.2')
            .from(graciasRef.value, { opacity: 0, y: 10 }, '-=0.2')
            .from(separadorRef.value, { opacity: 0, scaleX: 0, duration: 0.4 })

          tl.add(() => {
            crearLluvia(lluviaDer.value)
            crearLluvia(lluviaIzq.value)
          })

          tl.from(textoNinosRef.value, {
            opacity: 0,
            y: 20,
            duration: 0.6
          }, '+=0.4')

          tl.add(() => {
            crearLluvia(lluviaNinosDer.value)
            crearLluvia(lluviaNinosIzq.value)
          })
        }
      })

      // ✨ estrellas animadas (suave y elegante)
      const stars = [
        star1.value, star2.value, star3.value,
        star4.value, star5.value, star6.value
      ]

      stars.forEach((star, i) => {
        if (!star) return

        gsap.to(star, {
          y: '+=6',
          duration: 2 + i * 0.2,
          repeat: -1,
          yoyo: true,
          ease: 'sine.inOut'
        })

        gsap.fromTo(
          star,
          { opacity: 0.5, scale: 0.8 },
          {
            opacity: 1,
            scale: 1.1,
            duration: 1.8,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          }
        )
      })
    })

    onUnmounted(() => {
      if (st1) st1.kill()
      ScrollTrigger.refresh()
    })

    return {
      raiz,
      tituloRef,
      textoRef,
      sobreRef,
      graciasRef,
      separadorRef,
      raizNinos,
      textoNinosRef,
      lluviaNinosIzq,
      lluviaNinosDer,
      sobrePng,
      star1, star2, star3, star4, star5, star6
    }
  }
}
</script>

<style scoped>
.separador{
  width: 60%;
  height: 2px;
  background: rgba(255,255,255,0.6);
  margin: 50px auto;
}

.lluvia-sobres{
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: -8px 20px 58px;
  text-align: center;
  background: #8fbbdf;
  overflow: hidden;
}

.contenido{
  position: relative;
  z-index: 2;
  margin-bottom: 50px;
}

/* ⭐ ESTRELLAS */
.star{
  position: absolute;
  width: 120px;
  z-index: 1;
  pointer-events: none;
  opacity: 0.7;
}

.star-1{ top: 40px; left: -19px; }
.star-2{ top: 100px; right: -19px; }
.star-3{ bottom: 80px; left: -19px; }
.star-4{ bottom: 30px; right: -19px; }

.star-5{ top: 30px; left: 10px; opacity: 0 !important; }
.star-6{ bottom: 30px; right: 10px;opacity: 0 !important;  }

.titulo{
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif{
  font-family: "titulos", cursive;
  font-size: 66px;
}
.titulo .script{
  font-family: 'nombre', cursive;
  font-size: 44px;
}

.texto{
  font-family: 'quote', serif;
  color: #fff;  margin-left: 20px;
  margin-right: 20px;
  font-size: 20px;   margin: 0 20px; /* 🔥 margen izquierdo y derecho */
 /* 🔥 margen arriba/abajo y centrado */

}

.icono-sobre{
  width: 110px;
  margin: 8px auto;
}

.gracias{
  font-family: 'padres', serif;
  font-size: 24px;
  color: #fff;
  font-weight: 800;
}

.lluvia{
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 1;
}

.sobre-lluvia{
  position: absolute;
  top: -10%;
  width: 28px;
}

@media (max-width: 380px){
  .titulo .serif{ font-size: 50px; }
  .titulo .script{ font-size: 40px; }
}
</style>